import { MAINTENANCE_CATEGORIES, MAINTENANCE_STATUSES, MAINTENANCE_PRIORITIES } from '../../utils/enums';

export const CATEGORY_META = {
    [MAINTENANCE_CATEGORIES.REPAIR]: { label: 'Repair' },
    [MAINTENANCE_CATEGORIES.MAINTENANCE]: { label: 'Maintenance' },
    [MAINTENANCE_CATEGORIES.DECOR]: { label: 'Decor' },
    [MAINTENANCE_CATEGORIES.ENHANCEMENT]: { label: 'Enhancement' },
    [MAINTENANCE_CATEGORIES.NEW]: { label: 'New' },
    [MAINTENANCE_CATEGORIES.OTHER]: { label: 'Other' },
};

export const PRIORITY_META = {
    [MAINTENANCE_PRIORITIES.URGENT]: { label: 'Urgent', badgeClass: 'bg-red-100 text-red-700' },
    [MAINTENANCE_PRIORITIES.HIGH]: { label: 'High', badgeClass: 'bg-red-50 text-red-600' },
    [MAINTENANCE_PRIORITIES.MEDIUM]: { label: 'Medium', badgeClass: 'bg-orange-50 text-orange-600' },
    [MAINTENANCE_PRIORITIES.LOW]: { label: 'Low', badgeClass: 'bg-green-50 text-green-600' },
};

export const STATUS_META = {
    [MAINTENANCE_STATUSES.TODO]: { label: 'To Do' },
    [MAINTENANCE_STATUSES.IN_PROGRESS]: { label: 'In Progress' },
    [MAINTENANCE_STATUSES.ON_HOLD]: { label: 'On Hold' },
    [MAINTENANCE_STATUSES.COMPLETED]: { label: 'Completed' },
    [MAINTENANCE_STATUSES.CANCELLED]: { label: 'Cancelled' },
};

// Fixed column order for the board — SRD's 4 default columns plus Cancelled.
export const STATUS_COLUMNS = [
    MAINTENANCE_STATUSES.TODO,
    MAINTENANCE_STATUSES.IN_PROGRESS,
    MAINTENANCE_STATUSES.ON_HOLD,
    MAINTENANCE_STATUSES.COMPLETED,
    MAINTENANCE_STATUSES.CANCELLED,
];

// One location's full path. Used on its own in the detail page's location list.
export const getSingleLocationLabel = (location) => {
    const parts = [
        location?.branch?.name,
        location?.building?.name,
        location?.floor ? `Floor ${location.floor.number}` : null,
        location?.space || null,
    ].filter(Boolean);
    return parts.join(' / ') || '—';
};

// Work orders created before multi-location support carry their single location in
// top-level branch/building/floor/space instead of `locations`. The API normalizes this
// too, but doing it here as well keeps already-cached React Query data rendering
// correctly across the deploy. Remove once migrateMaintenanceLocations has been run.
export const getLocations = (workOrder) => {
    if (workOrder?.locations?.length > 0) return workOrder.locations;
    if (!workOrder?.floor) return [];
    return [{
        branch: workOrder.branch,
        building: workOrder.building,
        floor: workOrder.floor,
        space: workOrder.space || '',
    }];
};

// Summary for the places with one line to spare — a card, a list row, a tooltip. A work
// order spanning several floors shows the first plus a count ("… +3 more") rather than
// a joined string that would blow past the width available on a Kanban card.
export const getLocationLabel = (workOrder) => {
    const locations = getLocations(workOrder);
    if (locations.length === 0) return '—';

    const first = getSingleLocationLabel(locations[0]);
    return locations.length === 1 ? first : `${first} +${locations.length - 1} more`;
};

export const getInitials = (name) => {
    if (!name) return '—';
    const parts = name.trim().split(/\s+/);
    return parts.length > 1
        ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
        : parts[0].slice(0, 2).toUpperCase();
};

export const isOverdue = (workOrder) =>
    !!workOrder?.dueDate &&
    workOrder.status !== MAINTENANCE_STATUSES.COMPLETED &&
    workOrder.status !== MAINTENANCE_STATUSES.CANCELLED &&
    new Date(workOrder.dueDate) < new Date();
